import React from "react";
type ReportProps = React.PropsWithChildren<{}>;
function Report(props: ReportProps) {
	return <div className="h-full">{props.children}</div>;
}

export default Report;
